import PropTypes from "prop-types";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { IMaskInput } from "react-imask";
import Select from 'react-select';

const CadastroProvedorNaoCredenciadoModal = ({
    show,
    onHide,
    onSave,
    loading,
    formData,
    onFieldChange,
    onMaskedFieldChange,
    onCepChange,
    onEstadosChange,
    ufOptions,
    categorias,
    showCredenciadoField,
    defaultCredenciado,
}) => {
    return (
        <Modal show={show} onHide={onHide} size="xl" enforceFocus={false} backdropClassName="backdrop-level-2">
            <Modal.Header closeButton>
                <Modal.Title>Cadastrar provedor não credenciado</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col sm={12} xs={12}>
                        <Form.Label>Tipo Pessoa</Form.Label>
                        <div className="mb-3">
                            <Form.Check
                                inline
                                type="radio"
                                label="Física"
                                id="cadastro_provedor_tipo_pessoa_fisica"
                                name="tipo_pessoa"
                                value="fisica"
                                onChange={onFieldChange}
                                checked={formData.tipo_pessoa === 'fisica'}
                            />
                            <Form.Check
                                inline
                                type="radio"
                                label="Jurídica"
                                id="cadastro_provedor_tipo_pessoa_juridica"
                                name="tipo_pessoa"
                                value="juridica"
                                onChange={onFieldChange}
                                checked={formData.tipo_pessoa === 'juridica'}
                            />
                        </div>
                    </Col>

                    {formData.tipo_pessoa === 'fisica' ? (
                        <>
                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nome <span className="text-danger">*</span></Form.Label>
                                    <Form.Control type="text" name="nome" placeholder="Nome" value={formData.nome} onChange={onFieldChange} />
                                </Form.Group>
                            </Col>
                            <Col sm={3} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>CPF</Form.Label>
                                    <Form.Control as={IMaskInput} unmask="typed" mask="000.000.000-00" placeholder="CPF" name="cpf" value={formData.cpf} onAccept={(value) => onMaskedFieldChange('cpf', value)} />
                                </Form.Group>
                            </Col>
                            <Col sm={3} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Gênero <span className="text-danger">*</span></Form.Label>
                                    <Form.Control as="select" name="genero" value={formData.genero} onChange={onFieldChange}>
                                        <option value="">Selecione o Gênero</option>
                                        <option value="F">Feminino</option>
                                        <option value="M">Masculino</option>
                                        <option value="O">Outro</option>
                                    </Form.Control>
                                </Form.Group>
                            </Col>
                        </>
                    ) : (
                        <>
                            <Col sm={4} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>CNPJ <span className="text-danger">*</span></Form.Label>
                                    <Form.Control as={IMaskInput} unmask="typed" mask="00.000.000/0000-00" placeholder="CNPJ" name="cnpj" value={formData.cnpj} onAccept={(value) => onMaskedFieldChange('cnpj', value)} />
                                </Form.Group>
                            </Col>
                            <Col sm={4} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Razão Social <span className="text-danger">*</span></Form.Label>
                                    <Form.Control type="text" name="razao_social" placeholder="Razão Social" value={formData.razao_social} onChange={onFieldChange} />
                                </Form.Group>
                            </Col>
                            <Col sm={4} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nome Fantasia <span className="text-danger">*</span></Form.Label>
                                    <Form.Control type="text" name="nome_fantasia" placeholder="Nome fantasia" value={formData.nome_fantasia} onChange={onFieldChange} />
                                </Form.Group>
                            </Col>
                        </>
                    )}

                    <Col sm={4} xs={12}>
                        <Form.Group className="mb-3">
                            <Form.Label>E-mail</Form.Label>
                            <Form.Control type="email" name="email" placeholder="E-mail" value={formData.email} onChange={onFieldChange} />
                        </Form.Group>
                    </Col>
                    <Col sm={4} xs={12}>
                        <Form.Group className="mb-3">
                            <Form.Label>Telefone</Form.Label>
                            <Form.Control as={IMaskInput} mask="(00) 00000-0000" placeholder="Telefone do provedor" name="telefone" value={formData.telefone} onAccept={(value) => onMaskedFieldChange('telefone', value)} />
                        </Form.Group>
                    </Col>
                    <Col sm={4} xs={12}>
                        <Form.Group className="mb-3">
                            <Form.Label>Celular</Form.Label>
                            <Form.Control as={IMaskInput} mask="(00) 00000-0000" placeholder="Celular do provedor" name="celular" value={formData.celular} onAccept={(value) => onMaskedFieldChange('celular', value)} />
                        </Form.Group>
                    </Col>

                    <Col sm={4} xs={12}>
                        <Form.Group className="mb-3">
                            <Form.Label>Categoria</Form.Label>
                            <Form.Control as="select" name="categoria" value={formData.categoria} onChange={onFieldChange}>
                                <option value="">Selecione a Categoria</option>
                                {Object.entries(categorias).map(([chave, valor]) => (
                                    <option key={chave} value={chave}>{valor}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>

                    {showCredenciadoField && (
                        <Col sm={4} xs={12}>
                            <Form.Group className="mb-3">
                                <Form.Label>Provedor Credenciado</Form.Label>
                                <Form.Control as="select" disabled value={defaultCredenciado ? 'sim' : 'nao'}>
                                    <option value="sim">Sim</option>
                                    <option value="nao">Não</option>
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    )}

                    <Col sm={12}><h5 className="mt-2">Endereço</h5></Col>
                    <Col sm={3} xs={12}>
                        <Form.Group className="mb-3">
                            <Form.Label>CEP <span className="text-danger">*</span></Form.Label>
                            <Form.Control as={IMaskInput} mask="00000-000" type="text" placeholder="CEP" value={formData.cep} onAccept={onCepChange} required />
                        </Form.Group>
                    </Col>
                    <Col sm={3} xs={12}>
                        <Form.Group className="mb-3">
                            <Form.Label>UF <span className="text-danger">*</span></Form.Label>
                            <Form.Control as="select" name="uf" value={formData.uf} onChange={onFieldChange} required>
                                <option value="">Selecione o Estado</option>
                                {Object.entries(ufOptions).map(([sigla, nome]) => (
                                    <option key={sigla} value={sigla}>{nome}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col sm={6} xs={12}>
                        <Form.Group className="mb-3">
                            <Form.Label>Estados de Atendimento</Form.Label>
                            <Select
                                isMulti
                                options={Object.entries(ufOptions).map(([sigla, nome]) => ({ value: sigla, label: nome }))}
                                value={(formData.estados_atendimento || []).map(sigla => ({ value: sigla, label: ufOptions[sigla] || sigla }))}
                                onChange={onEstadosChange}
                                placeholder="Selecione os estados..."
                                classNamePrefix="select"
                            />
                        </Form.Group>
                    </Col>
                    <Col sm={4} xs={12}>
                        <Form.Group className="mb-3">
                            <Form.Label>Cidade <span className="text-danger">*</span></Form.Label>
                            <Form.Control type="text" name="cidade" placeholder="Cidade" value={formData.cidade} onChange={onFieldChange} required />
                        </Form.Group>
                    </Col>
                    <Col sm={4} xs={12}>
                        <Form.Group className="mb-3">
                            <Form.Label>Bairro <span className="text-danger">*</span></Form.Label>
                            <Form.Control type="text" name="bairro" placeholder="Bairro" value={formData.bairro} onChange={onFieldChange} required />
                        </Form.Group>
                    </Col>
                    <Col sm={4} xs={12}>
                        <Form.Group className="mb-3">
                            <Form.Label>Endereço <span className="text-danger">*</span></Form.Label>
                            <Form.Control type="text" name="endereco" placeholder="Endereço" value={formData.endereco} onChange={onFieldChange} required />
                        </Form.Group>
                    </Col>
                    <Col sm={4} xs={12}>
                        <Form.Group className="mb-3">
                            <Form.Label>Número <span className="text-danger">*</span></Form.Label>
                            <Form.Control type="text" name="numero" placeholder="Número" value={formData.numero} onChange={onFieldChange} required />
                        </Form.Group>
                    </Col>
                    <Col sm={4} xs={12}>
                        <Form.Group className="mb-3">
                            <Form.Label>Complemento</Form.Label>
                            <Form.Control type="text" name="complemento" placeholder="Complemento" value={formData.complemento} onChange={onFieldChange} />
                        </Form.Group>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary-outline" onClick={onHide}>
                    Cancelar
                </Button>
                <Button variant="success" onClick={onSave} disabled={loading}>
                    {loading ? <span className="spinner-border spinner-border-sm"></span> : 'Salvar provedor'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

CadastroProvedorNaoCredenciadoModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    formData: PropTypes.object.isRequired,
    onFieldChange: PropTypes.func.isRequired,
    onMaskedFieldChange: PropTypes.func.isRequired,
    onCepChange: PropTypes.func.isRequired,
    onEstadosChange: PropTypes.func.isRequired,
    ufOptions: PropTypes.object.isRequired,
    categorias: PropTypes.object.isRequired,
    showCredenciadoField: PropTypes.bool,
    defaultCredenciado: PropTypes.bool,
};

CadastroProvedorNaoCredenciadoModal.defaultProps = {
    loading: false,
    showCredenciadoField: true,
    defaultCredenciado: false,
};

export default CadastroProvedorNaoCredenciadoModal;
